export class HomeAction {
  static readonly type = '[Home] Add item';
  constructor(public payload: string) { }
}


export class LoadDashboard {
  static readonly type = '[Home] Load Dashboard';
  constructor(public from: Date, public to: Date) { }
}


export class LoadTransactions {
  static readonly type = '[Home] Load Transactions';
  constructor(public from: Date, public to: Date) { }
}

export class LoadSummary {
  static readonly type = '[Home] Load Summary';
  constructor(public from: Date, public to: Date) { }
}

export class UpdateFilter {
  static readonly type = '[Home] Update Filter';
  constructor(public from: Date, public to: Date) { }
}
